<template>
    <div class="bg-white shadow-lg rounded-lg overflow-hidden">
        <div class="bg-primary text-white p-4">
            <h3 class="text-xl font-semibold">Survey Overview</h3>
        </div>
        <div class="p-6 space-y-4">
            <div class="grid grid-cols-2 gap-4">
                <div v-for="(stat, index) in surveyStats" :key="index" class="bg-gray-100 p-4 rounded-lg">
                    <h4 class="text-lg font-semibold text-primary">{{ stat.label }}</h4>
                    <p class="text-3xl font-bold text-primary-light">{{ stat.value }}</p>
                </div>
            </div>
            <div class="mt-6">
                <h4 class="text-lg font-semibold text-primary mb-2">Survey Completion Rates</h4>
                <div class="h-64">
                    <canvas ref="chartCanvas"></canvas>
                </div>
            </div>
            <div class="mt-6">
                <h4 class="text-lg font-semibold text-primary mb-2">Recent Surveys</h4>
                <ul class="space-y-2">
                    <li v-for="survey in recentSurveys" :key="survey.id"
                        class="flex justify-between items-center bg-gray-50 p-2 rounded">
                        <span>{{ survey.name }}</span>
                        <span :class="getStatusClass(survey.status)">{{ survey.status }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js/auto';
import { surveyApi } from '@/api/surveyManagement';

export default {
    name: 'SurveyOverview',
    data() {
        return {
            overview: {},
            surveyStats: [
                { label: 'Active Surveys', value: 0 },
                { label: 'Pending Surveys', value: 0 },
                { label: 'Completed Surveys', value: 0 },
                { label: 'Total Responses', value: 0 }
            ],
            recentSurveys: [
            
            ],
            chart: null
        }
    },
    async mounted() {
        await this.fetchSurveyOverview();
    },
    methods: {
        async fetchSurveyOverview() {
            try {
                this.loading = true;
                this.overview = await surveyApi.getSurveyOverview();
                this.surveyStats[0].value = this.overview.activeSurveys;
                this.surveyStats[1].value = this.overview.pendingSurveys;
                this.surveyStats[2].value = this.overview.completedSurveys;
                this.surveyStats[3].value = this.overview.totalResponses;
                this.recentSurveys = this.overview.recentSurveys;

                this.createChart();
            } catch (error) {
                console.error('Error fetching survey overview:', error);
                this.error = 'Failed to load survey overview. Please try again later.';
            } finally {
                this.loading = false;
            }
        },
        createChart() {
            const ctx = this.$refs.chartCanvas.getContext('2d');
            this.chart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: ['Completed', 'Active', 'Pending'],
                    datasets: [{
                        data: [this.overview.completedSurveys, this.overview.activeSurveys, this.overview.pendingSurveys],
                        backgroundColor: [
                            'rgba(37, 99, 235, 0.8)',
                            'rgba(5, 150, 105, 0.8)',
                            'rgba(217, 119, 6, 0.8)',
                        ]
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom'
                        }
                    }
                }
            });
        },
        getStatusClass(status) {
            switch (status.toLowerCase()) {
                case 'active':
                    return 'text-green-600 font-semibold';
                case 'pending':
                    return 'text-yellow-600 font-semibold';
                case 'completed':
                    return 'text-blue-600 font-semibold';
                default:
                    return 'text-gray-600';
            }
        }
    }
}
</script>